import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'

import AccountRepository from '@/shared/http/repositories/access/account'
import AccountModel from '@/shared/models/access/accountmodel'
import AccountForms from './profile-form'
import { mapActions, mapGetters } from 'vuex'
import Tools from '@/components/tools/Tools'
import { globalActions as authActions } from '@/store/module/auth/actionTypes'

export default {
  name: 'profile',
  mixins: [ActionsForm],
  data () {
    return {
      data: AccountModel,
      form: AccountForms
    }
  },
  computed: {
    ...mapGetters('auth', ['userInfo'])
  },
  methods: {
    ...mapActions(
      {
        setUserInfo: authActions.SET_USER_INFO
      }
    ),
    onLoad () {
      this.data = Object.assign({}, this.userInfo)
      if (this.data) {
        Tools.SetValueInForm(this.form, this.data, this.userInfo)
        this.data.senha = null
        this.data.enviaEmail = this.userInfo.enviaEmail
      }
    },
    onUpdate () {
      loading.push()
      if (!this.form.senhaNova.value || (this.form.senhaNova.value && this.form.senhaNova.value === this.form.confirmacao.value)) {
        this.data.senha = this.form.senhaNova.value ? this.form.senhaNova.value.toString() : null
        this.data.status = 1
        AccountRepository.Update(this.data)
          .then((response) => {
            this.onResult(response)
            this.setUserInfo(response.data.data)
            this.$router.push({name: 'StartPage'})
          })
          .catch((err) => {
            this.onException(err)
          })
      } else {
        toast.error('Senha e Confirmação são diferentes!')
      }
    },
    onCheckUsername () {
      var username = this.form.username.value
      loading.push()
      AccountRepository.GetByUsername(username)
        .then((response) => {
          if (response) {
            if (response.data.data) {
              var obj = response.data.data
              if (obj) {
                toast.warning(this.$lang.Accounts.AlertEmailExisted)
              }
            }
          }
          loading.pop()
        })
        .catch((err) => {
          this.onException(err)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/myaccount/profile/profile.js